import userGroupTabTemplate from './userGroupTabTemplate';

export default userGroupTabTemplate(['usergroups'], ({ usergroups }) => usergroups.read);
